<template>
  <v-app class="app-wrapper">
    <router-view />
    <Snackbar />
  </v-app>
</template>

<script>
import Snackbar from '@/components/shared/Snackbar';
export default {
  name: 'App',
  components: {
    Snackbar,
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/index.scss';
</style>
